export default __webpack_public_path__ + "static/brecon-wind-turbine-bd62515089e9c0c6182e018b7c09587d.jpg";